import { motion } from "framer-motion";
import { ShieldCheck, Scale, Briefcase, Activity, Landmark } from "lucide-react";

const icons = [ShieldCheck, Scale, Briefcase, Activity, Landmark];
const testids = ["service-card-audit", "service-card-revision", "service-card-conseil", "service-card-risques", "service-card-compliance"];

export const Services = ({ t }) => (
  <section id="services" className="py-28 bg-[#0A101D]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-16"
      >
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-[#E2C376] mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-[#D4AF37]" /> {t.services.eyebrow}
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-slate-50 tracking-tight max-w-xl">{t.services.title}</h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {t.services.items.map((s, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={testids[i]}
              data-testid={testids[i]}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`group relative bg-[#111A2E] border border-[#D4AF37]/15 p-8 lg:p-10 hover:border-[#D4AF37]/50 transition-colors duration-500 ${
                i === 0 ? "md:col-span-2 lg:col-span-2" : ""
              }`}
            >
              <div className="absolute top-0 left-0 w-0 h-px bg-[#D4AF37] group-hover:w-full transition-all duration-700" />
              <div className="flex items-center justify-between mb-8">
                <Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.2} />
                <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
              </div>
              <h3 className="font-serif text-xl sm:text-2xl text-amber-200/90 mb-4">{s.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
